// extracted by mini-css-extract-plugin
export var animationContainer = "_ar-0";
export var asteriskIcon = "_ar-8";
export var conversationLeftSection = "_ar-4";
export var conversationListItem = "_ar-3";
export var conversationMiddleSection = "_ar-5";
export var conversationRightSection = "_ar-6";
export var detailsContent = "_ar-1";
export var listContainer = "_ar-7";
export var modalContent = "_ar-2";